import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { StyledHorizontalScrollDiv, StyledTable } from "../../../../useGeneralStyles";
import { ComplianceAPI } from "../../../../api/compliance";
import { ContainerWithLoader } from "../../../../components/ui";

import TableHead from "./TableHead";
import TableBody from "./TableBody";
import { SearchByListValues } from "../../../../components/ui";
import { complianceSearchActions } from "../../../../reducers/complianceSearch";
import { getQueryStringByStringValues } from "../../utils";
import { EMAILS_LIST_VALIDATION_SCHEMA } from "../../../../utils/validation";
import { useComplianceSearchContext } from "../../../../context";
import { SectionTitle, TableWrapper } from "../../styledComponents";

const SearchAccountsPlans = (): React.ReactElement => {
  const dispatch = useDispatch();

  const { tabsTablesSearchState, setTabsTablesSearchState } = useComplianceSearchContext();
  const { emails } = tabsTablesSearchState.quickSearchTab.searchAccountsPlansTable.search;

  const {
    data: { accounts },
    loading,
  } = useSelector((state) => state.complianceSearch.plans);

  const fetchData = async (values: { emails: string }) => {
    setTabsTablesSearchState({
      ...tabsTablesSearchState,
      quickSearchTab: {
        ...tabsTablesSearchState.quickSearchTab,
        searchAccountsPlansTable: {
          search: { emails: values.emails },
        },
      },
    });

    try {
      dispatch(complianceSearchActions.fetchPlansRequest());
      const response = await ComplianceAPI.getAccountPlans(
        getQueryStringByStringValues("emails", values.emails)
      );
      dispatch(complianceSearchActions.fetchPlansSuccess(response.data));
    } catch (error) {
      console.log("error SearchAccountsPlans fetching data", error);
      dispatch(complianceSearchActions.fetchPlansFailed());
    }
  };

  return (
    <SectionTitle title="Search plans data">
      <SearchByListValues
        validationSchema={EMAILS_LIST_VALIDATION_SCHEMA}
        isLoading={loading}
        fetchData={fetchData}
        placeholder="john@gmail.com, doe@gmail.com e.t.c ..."
        label="Emails"
        name="emails"
        initialValues={{ emails }}
      />

      <TableWrapper>
        <ContainerWithLoader isLoading={loading} report={accounts}>
          <StyledHorizontalScrollDiv>
            <StyledTable smTable tableWithoutHover noTextWrap>
              <TableHead />
              <TableBody />
            </StyledTable>
          </StyledHorizontalScrollDiv>
        </ContainerWithLoader>
      </TableWrapper>
    </SectionTitle>
  );
};

export default SearchAccountsPlans;
